/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
let imgArr = [
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/1_j.png?v=1737431051',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/1y.png?v=1737431051',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro1.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro2.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro3.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro4.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro5.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro6.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro7.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro8.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro9.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/20260415-pro10.jpg',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/2y.png?v=1737431051',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/3j_4c47a99f-2010-42fb-9874-9c550bb0f335.png?v=1737432514',
  'https://cdn.shopify.com/s/files/1/0553/4220/2938/files/3y_a71163e2-1269-4a7b-a283-fde0d079b321.png?v=1737432514',
]
document.addEventListener("DOMContentLoaded", function () {
let spImgList = [
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-p1.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-p2.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-p3.png",

"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b1.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b2.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b3.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b4.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b5.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b6.png",
"https://cdn.shopify.com/s/files/1/0553/4220/2938/files/202501112-b7.png",
];

function mainRender() {
$(function () {
    function getRandomNum(min, max) {
return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
let nowTime = new Date();
let endTime = new Date(endTimeG);

let leftTime = endTime.getTime() - nowTime.getTime();
if (leftTime < 0) {
  setupNewCountdown();
  leftTime = 0;
}
let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
  leftM = Math.floor((leftTime / (1000 * 60)) % 60),
  leftS = Math.floor((leftTime / 1000) % 60);
leftH = leftH >= 10 ? leftH : "0" + leftH;
leftM = leftM >= 10 ? leftM : "0" + leftM;
leftS = leftS >= 10 ? leftS : "0" + leftS;

return {
  hour: leftH,
  minute: leftM,
  second: leftS,
};
}
function setupNewCountdown() {
const randomHour = getRandomNum(1, 9);
const currentTime = new Date();
endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
setupNewCountdown();
if (intervalId) clearInterval(intervalId);
intervalId = setInterval(function () {
  let cutDownTimeText = cutDownTime();
  $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
  $(".sp_top_cut_down .sp_left_view .sp_minute").html(
    cutDownTimeText.minute
  );
  $(".sp_top_cut_down .sp_left_view .sp_second").html(
    cutDownTimeText.second
  );
}, 1000);
}

getCutDownTime();
  $("#root").css("zoom", "normal");
  let scale = document.body.clientWidth / 1080;
  $("#root").css("zoom", scale);

  window.addEventListener(
    "resize",
    (function () {
      var timer;
      return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          $("#root").css("zoom", "normal");
          let scale = document.body.clientWidth / 1080;
          $("#root").css("zoom", scale);
        }, 100);
      };
    })()
  );
});

function lazyLoadImages() {
  // 懒加载
  const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
  const config = {
    rootMargin: "0px 0px 1300px 0px",
    threshold: 0,
  };

  const lazyLoadObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        // 当图片进入视口时
        const image = entry.target;
        const dataSrc = image.getAttribute("data-src");
        image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
        lazyLoadObserver.unobserve(image); // 停止观察该图片
      }
    });
  },
  config);

  images.forEach(function (image) {
    lazyLoadObserver.observe(image); // 开始观察每个图片
  });
}

function preloadImages(imageArray) {
  // 预加载
  // 检查数组数据结构
  if (Array.isArray(imageArray[0])) {
    // 处理二维数组
    imageArray.forEach((subArray) => {
      subArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    });
  } else {
    // 处理一维数组
    imageArray.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }
}

lazyLoadImages();

preloadImages(imgArr);

// 找到所有跳转套餐的锚点链接
var links = document.querySelectorAll('a[href^="#shopping"]');
links.forEach(function (link) {
  link.addEventListener("click", function (event) {
    event.preventDefault(); // 阻止默认的跳转行为
    // var targetElement = document.getElementById('shopping');
    // if (targetElement) {
    //     targetElement.scrollIntoView({ behavior: 'smooth' });
    // } // 方式一
    const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
    const offsetTop = targetElement.offsetTop;
    window.scroll({
      top:
        offsetTop * $("div#root").css("zoom") -
        300 * $("div#root").css("zoom"),
      behavior: "smooth", // 使用 smooth 实现平滑滚动
    }); // 方式二
  });
});

// IOS字体多了间距的处理 给节点添加 sp_system 类名
// 判断当前用户是安卓端还是iOS端
var userAgent = navigator.userAgent || navigator.vendor || window.opera;
var isAndroid = /android/i.test(userAgent);
var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

if (isAndroid) {
  console.log("Android");
} else if (isIOS) {
  console.log("iOS");
} else if (isPC) {
  console.log("PC");
} else {
  $(".sp_system").css("letter-spacing", "-4px");
}
}

mainRender();

new Swiper("#sp-swiper2", {
autoplay: true,
speed: 6000,
autoplay: {
  delay: 1,
  disableOnInteraction: false,
  // reverseDirection: true,
},
spaceBetween: 0,
slidesPerView: "auto",
centeredSlides: true,
loop: true,
});
new Swiper(".sp-swiper1", {
autoplay: true,
autoplay: {
  disableOnInteraction: false,
},
spaceBetween: 0,
slidesPerView: "auto",
centeredSlides: true,
loop: true,
pagination: {
  el: ".sp-pagination1",
  clickable: true,
},
});
  // 初始化
alignmentFns.initialize()
// 数量
let prods = window.product
console.log(prods)
function getCur(){
  let color = $('.sp-color-wraper li.active').attr('data-val')
  let size = $('.sp-size-wraper li.active').attr('data-val')
  let style = $('.sp-style-wraper li.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == size && item.option3 == style)[0]
}
function changePrice(){
  let num = $('#2').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#new').html(price)
  $('#old').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);
}
if (window.cartCount == 0) {
  $('.buy-car span').css('background', '#999')
} else {
  $('.buy-car span').css('background', '#f24a00')
}
$('.sp-buynow').click(function(){
  let num = $('#2').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
$('#addCart').click(function () {
  // do something here
  var data = {
    id: getCur().id,
    quantity: $('#2').val(),
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $(".buy-car span").html(result.item_count);
        if (result.item_count == 0) {
          $('.buy-car span').css('background', '#999')
        } else {
          $('.buy-car span').css('background', '#f24a00')
        }
      });
    },
    dataType: "json",
  });
  
  var img = $('.sp-pro-img img')
  var flyer = img[0].cloneNode(true)
  flyer.classList.add('clone')
  $('.sp-part5').append(flyer)
  $('.clone').css({
    width: '980px',
    height: '500px',
    position: 'fixed',
    top: img[0].offsetTop,
    left: img.offset().left,
    'z-index': '99',
  })
  var offset = $('.buy-car')[0].getBoundingClientRect()
  $('.buy-car').addClass('shake')
  setTimeout(() => {
    $('.buy-car').removeClass('shake')
  }, 1000)
  let finish = $('.buy-car')
  $('.clone').animate(
    {
      top: finish[0].offsetTop + 120,
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    1000,
    'linear',
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0,
        function () {
          $(this).detach() // 完成动画后移除克隆的图片
        }
      )
    }
  )
})
$('#2').change(function () {
  changePrice()
  freeFunc()
})
// 包邮
function freeFunc() {
  var freeShopping = 80
  if (Number($('#new').html().replace(',', '.')) >= freeShopping) {
    $('.sp-buynow').addClass('sp-freeshop')
    
  } else {
    $('.sp-buynow').removeClass('sp-freeshop')

  }
}

// 颜色选择
$('.sp-size-wraper li,.sp-color-wraper li,.sp-style-wraper li').click(function () {
  $(this).addClass('active').siblings().removeClass('active')
  const index = $('.sp-color-wraper li.active').index()
  const index3 = $('.sp-size-wraper li.active').index()
  const index2= $('.sp-style-wraper li.active').index()

  $('.sp-pro-img .sp-pro').attr('src', imgArr[index + index3*4])
  console.log(index + index2*2)
  // if(index3>0){
  //   $('.sp-pro-img .sp-num').show()
  //   $('.sp-pro-img .sp-num').html(`x${index3*2 + 1}`)
    
  // }else{
  //   $('.sp-pro-img .sp-num').hide()
    
  // }
//   if(index3 == 2){
// $('.sp-pro-img .sp-free').show()
//   }else{
// $('.sp-pro-img .sp-free').hide()
//   }
  changePrice()
  freeFunc()
})
// $('.sp-color-wraper li').click(function () {
//   var index = $(this).index()
//   var index2 = $('.sp-color-wraper li.active').index()
//   console.log(index,index2)
//   $('.sp-pro-img .sp-pro').attr('src', imgArr[index + index2*3])
//   changePrice()
//   freeFunc()
// })
// $('.sp-style-wraper li').click(function () {
//   var index = $(this).index()
//   var index2 = $('.sp-color-wraper li.active').index()
//   $('.sp-pro-img .sp-pro').attr('src', imgArr[index*3 + index2])
//   changePrice()
//   freeFunc()
// })
// $(".sp-option").click(function () {
//   $(this).addClass("active").siblings().removeClass("active");
//   // let sp_img = $(this).parents(".product-box");
//   // let _numIndex = sp_img.index();
//   // let _sizeIndex = $(this).index();
//   // let spUrl = spImgList[_numIndex + _sizeIndex * 3];
//   // sp_img.find(".p-img")[0].srcset = spUrl;
// });
// $('.sp-btn-style').click(function(){
  //   let id = $(this).siblings('.sp-opt-wrap').find('div.active').attr('data-id')
  //   window.location.href = '/cart/' + id + ':' + 1
  // })
});
